import { userRes } from '@/api'
export default {
    state: {
        userInfo: {},
        menu: []
    },
    getters: {
        baseUserInfo(state) { 
            return state.userInfo || {}
        },
        userInfo(state) {
            return state.userInfo.userInfo ||{}
        },
        getUserRole(state) {
            return state.userInfo.type
        },
        getMenu(state) {
            return state.menu
        }
    },
    mutations: {
        SET_USER_INFO: (state, data) => {
            state.userInfo = data
        },
        SET_MENU: (state, data) => {
            state.menu = data
        }
    },
    actions: {
        getUserInfo: ({ commit, state }) => {
            return new Promise((resolve, reject) => {
                userRes.getUserInfo().then(res => {
                    commit('SET_USER_INFO', res)
                    resolve(res)
                })
            })
        },
        setMenu: ({ commit, state }, menu) => {
            commit('SET_MENU', menu)
        }
    }
}
